/* eslint-disable max-len */

export const SIZE_GUIDE_CHIPS = [
	{ label: 'Large', url: '/self-storage-sizes/large-self-storage/' },
	{ label: 'Medium', url: '/self-storage-sizes/medium-self-storage/' },
	{ label: 'Small', url: '/self-storage-sizes/small-self-storage/' },
	{ label: 'Lockers', url: '/self-storage-sizes/self-storage-lockers/' },
	{ label: 'Mini', url: '/self-storage-sizes/mini-self-storage/' },
];

export const SIZE_GUIDE_HERO_CONTENT = {
	subtitle: 'Self Storage Size Guide',
	title: 'What Size Self Storage Unit Do I Need?',
	description: [
		'Finding the right fit for your self storage needs doesn’t have to be a guessing game. We’re here to help you figure it out.',
		'From clearing out a spare bedroom and [organizing the garage](https://www.selfstorage.com/blog/self-storage-improves-garage-shed-organization/), to moving across town or even the country, one question comes to mind: _how much space do I actually need?_',
		"If you rent too small a space, you're cramming things together and immediately shopping for an upgrade. If you go too large, you're paying for space you don't need. Let's take a look at the most common self-storage unit sizes, what fits in each, and how to find the best unit for your specific situation, so you can rent with all of the confidence and none of the second-guessing.",
	],
};

export const SIZE_GUIDE_METADATA = {
	title: 'The Self Storage Size Guide | SelfStorage.com',
	description:
		"Before you rent, check SelfStorage.com's self storage size guide. We cover every size, break down pricing, and help you save money on your unit.",
	canonical: '/self-storage-sizes/',
};
